import { useEffect, useState } from "react";

function Topbar({ toggleSidebar }) {
  const [dateTime, setDateTime] = useState("");

  // ✅ GET USER
  const user = JSON.parse(localStorage.getItem("user"));

  // ✅ GET INITIALS (FIRST 2 LETTERS)
  const getInitials = (name) => {
    if (!name) return "U";
    return name.substring(0, 2).toUpperCase();
  };

  // ✅ LIVE DATE & TIME
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      const formatted = now.toLocaleString("en-GB", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

      setDateTime(formatted);
    };

    updateTime(); // initial
    const interval = setInterval(updateTime, 1000); // every second

    return () => clearInterval(interval);
  }, []);

  return (
    <header className="topbar">

      <div className="tb-left">
        <div className="hamburger" onClick={toggleSidebar}>
          ☰
        </div>
        <div className="tb-title">
          {/* Welcome  {user?.role?.toLowerCase()} */}
          </div>
      </div>

      <div className="tb-right">
        {/* ✅ LIVE DATE TIME */}
        <div className="tb-chip">{dateTime}</div>

        {/* ✅ USER INITIALS */}
        <div className="tb-ava">
          {getInitials(user?.name)}
        </div>
      </div>

    </header>
  );
}

export default Topbar;